import * as ward from 'src/api/ward'
import router from 'src/router'
import {
  GET_ALL_WARD,
  GET_WARD_TO,
  GET_WARD_FROM,
  SET_LOADED_WARD_BY_DISTRICT_CODE,
  SET_LOADED_WARD_BY_DISTRICT_ID,
  GET_WARD
} from 'src/store/mutation-types'

const getAllWard = ({commit, dispatch, state}, params) => {
  if (params.district_code && state.wardsByDistrictCode[params.district_code] && state.wardsByDistrictCode[params.district_code].length) {
    commit(GET_ALL_WARD, state.wardsByDistrictCode[params.district_code])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    ward.getAllWard(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ALL_WARD, response.data)
        if (params.district_code) {
          commit(SET_LOADED_WARD_BY_DISTRICT_CODE, {district_code: params.district_code, wards: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ALL_WARD, [])
      }
    })
  }
}

const getAllWardTo = ({commit, dispatch, state}, params) => {
  if (params.district_code && state.wardsByDistrictCode[params.district_code] && state.wardsByDistrictCode[params.district_code].length) {
    commit(GET_WARD_TO, state.wardsByDistrictCode[params.district_code])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    ward.getAllWard(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_WARD_TO, response.data)
        if (params.district_code) {
          commit(SET_LOADED_WARD_BY_DISTRICT_CODE, {district_code: params.district_code, wards: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_WARD_TO, [])
      }
    })
  }
}

const getAllWardFrom = ({commit, dispatch, state}, params) => {
  if (params.district_code && state.wardsByDistrictCode[params.district_code] && state.wardsByDistrictCode[params.district_code].length) {
    commit(GET_WARD_FROM, state.wardsByDistrictCode[params.district_code])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    ward.getAllWard(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_WARD_FROM, response.data)
        if (params.district_code) {
          commit(SET_LOADED_WARD_BY_DISTRICT_CODE, {district_code: params.district_code, wards: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_WARD_FROM, [])
      }
    })
  }
}

const getWardByDistrictId = ({commit, dispatch, state}, params = {}) => {
  if (params.district_id && state.wardsByDistrictId[params.district_id] && state.wardsByDistrictId[params.district_id].length) {
    commit(GET_ALL_WARD, state.wardsByDistrictId[params.district_id])
  } else {
    dispatch('toggleLoadding', true, {root: true})
    ward.getAllWard(params).then(response => {
      if (response.code === 200) {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ALL_WARD, response.data)
        if (params.district_id) {
          commit(SET_LOADED_WARD_BY_DISTRICT_ID, {district_id: params.district_id, wards: response.data})
        }
      } else {
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ALL_WARD, [])
      }
    })
  }
}

const getWard = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  ward.getWard(configs.id, configs.params).then(response => {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_WARD, response.data)
        break
      case 404:
        dispatch('toggleLoadding', false, {root: true})
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Quận huyện không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
        router.push({name: 'ward'})
        break
      default:
        dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setWard = ({commit}, ward) => {
  commit(GET_WARD, ward)
}

export default{
  getAllWard,
  getAllWardTo,
  getAllWardFrom,
  getWardByDistrictId,
  getWard,
  setWard
}



// WEBPACK FOOTER //
// ./src/components/ward/store/actions.js